import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface LabelBadgeProps {
  label: { displayName: string; color?: string | null; isSystem?: boolean };
  size?: 'sm' | 'default';
  className?: string;
}

const colorMap: Record<string, string> = {
  blue: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  red: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
  green: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  purple: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
  amber: 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200',
  orange: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200',
  cyan: 'bg-cyan-100 text-cyan-800 dark:bg-cyan-900 dark:text-cyan-200',
  slate: 'bg-slate-100 text-slate-800 dark:bg-slate-900 dark:text-slate-200',
  indigo: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-200',
  teal: 'bg-teal-100 text-teal-800 dark:bg-teal-900 dark:text-teal-200',
  violet: 'bg-violet-100 text-violet-800 dark:bg-violet-900 dark:text-violet-200',
  gray: 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200',
};

export function LabelBadge({
  label,
  size = 'default',
  className,
}: LabelBadgeProps): React.ReactElement {
  const colorClasses = label.color ? colorMap[label.color] : undefined;

  if (colorClasses) {
    return (
      <span
        className={cn(
          'inline-flex items-center rounded-md border border-transparent font-medium',
          colorClasses,
          size === 'sm' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-xs',
          className
        )}
      >
        {label.displayName}
      </span>
    );
  }

  return (
    <Badge
      variant="secondary"
      className={cn(size === 'sm' && 'px-1.5 py-0.5 text-[10px]', className)}
    >
      {label.displayName}
    </Badge>
  );
}
